import React, { useState } from "react";
import axios from "axios";
import { useLang } from "../LangContext";
import { Loader2, Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterSignup() {
    const { t } = useLang();
    const [email, setEmail] = useState("");
    const [consent, setConsent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(null); // "ok" | "already" | "err"

    const submit = async (e) => {
        e.preventDefault();
        if (!consent) return;
        setLoading(true);
        try {
            const { data } = await axios.post(`${API}/newsletter/subscribe`, {
                email, consent: true, source: "footer",
            });
            setDone(data.already_subscribed ? "already" : "ok");
            setEmail("");
        } catch (err) {
            setDone("err");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={submit} data-testid="newsletter-form" className="w-full">
            <div className="text-xs font-mono uppercase tracking-[0.3em] text-volt mb-3">
                — {t.footer.newsletter_eyebrow}
            </div>
            <h3 className="font-graffiti text-2xl md:text-3xl text-white tracking-tight leading-tight mb-5">
                {t.footer.newsletter_heading}
            </h3>
            <div className="flex flex-col sm:flex-row gap-3">
                <div className="relative flex-1">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" size={16} />
                    <input
                        data-testid="newsletter-email"
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={t.footer.newsletter_placeholder}
                        className="w-full bg-inksurface border border-white/10 pl-10 pr-4 py-3 text-white placeholder:text-zinc-500 focus:border-volt outline-none transition-colors"
                    />
                </div>
                <button
                    data-testid="newsletter-submit"
                    disabled={loading || !consent}
                    className="btn-volt px-6 py-3 text-xs inline-flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                    {loading ? <Loader2 className="animate-spin" size={14} /> : null}
                    {t.footer.newsletter_cta} →
                </button>
            </div>
            <label className="flex items-start gap-2 mt-3 text-xs text-zinc-400 leading-snug cursor-pointer">
                <input
                    data-testid="newsletter-consent"
                    type="checkbox"
                    checked={consent}
                    onChange={(e) => setConsent(e.target.checked)}
                    className="mt-0.5 accent-volt"
                />
                <span>{t.footer.newsletter_consent}</span>
            </label>
            {done === "ok" && (
                <p data-testid="newsletter-success" className="mt-3 text-xs text-volt font-mono">
                    ✓ {t.footer.newsletter_success}
                </p>
            )}
            {done === "already" && (
                <p className="mt-3 text-xs text-zinc-400 font-mono">{t.footer.newsletter_already}</p>
            )}
            {done === "err" && (
                <p className="mt-3 text-xs text-red-400 font-mono">{t.footer.newsletter_error}</p>
            )}
        </form>
    );
}
